import IconNotesPaperText from "@shared/components/icons/NotesPaperText"
import IconViewOff from "@shared/components/icons/ViewOff"
import { ChoiceButtons } from "@shared/components/menus/views/ChoiceButtons"
import { ViewShell } from "@shared/components/menus/views/ViewShell"

/**
 * "Do you want to leave a note?" — the day is being turned off either way; this decides
 * whether it says why. Without a note the class simply disappears from the day.
 */
export function LeaveNoteChoiceView({
  onLeaveNote,
  onHideClass,
}: {
  onLeaveNote: () => void
  onHideClass: () => void
}) {
  return (
    <ViewShell>
      <div className="px-5 pt-4 pb-5">
        <ChoiceButtons<"note" | "hide">
          ariaLabel="Do you want to leave a note?"
          onChoose={(choice) => (choice === "note" ? onLeaveNote() : onHideClass())}
          options={[
            {
              value: "note",
              label: "Yes, Leave a note",
              description: "For instance, “Dr. Appt”",
              icon: IconNotesPaperText,
            },
            {
              value: "hide",
              label: "No, Hide the class entirely",
              description: "It won’t show up at all.",
              icon: IconViewOff,
            },
          ]}
        />
      </div>
    </ViewShell>
  )
}
